<div class="ets-tabs-panel" id="wsp_{{wspId}}">
  <div #panel id="ets-panel">
    <ets-tab-header *ngFor="let tab of tabs"
                    [tab]="tab"
                    (tabClose)="onTabCloseRequest(tab)"
                    (click)="onTabClicked(tab)"
                    (headerChanged)="onTabHeaderChanged($event)"
                    (addedToPanel)="onTabAdded($event)"
                    (symbolLinkChanged)="onSymbolLinkChanged($event, tab)">
    </ets-tab-header>
  </div>

  <!-- Left paddle button -->
  <span class="ets-left-paddle ets-paddle"
        *ngIf="leftPaddleVisible"
        (click)="onLeftPaddleClick()">
    <i class="fas fa-chevron-circle-left fa-2x"></i>
  </span>

  <!-- Right paddle button -->
  <span class="ets-right-paddle ets-paddle"
        *ngIf="rightPaddleVisible"
        (click)="onRightPaddleClick()">
    <i class="fas fa-chevron-circle-right fa-2x"></i>
  </span>
</div>
